import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm$actionsStore$sele, _vm$actionsStore$sele2, _vm$actionsStore$sele3, _vm$actionsStore$sele4, _vm$actionsStore$sele5, _vm$actionsStore$sele6, _vm$actionsStore;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Número',
        field: 'numero'
      }, {
        type: 'text',
        label: 'Cliente',
        field: 'cliente'
      }, {
        type: 'text',
        label: 'Objeto',
        field: 'objeto'
      }, {
        type: 'text',
        label: 'Técnico',
        field: 'tecnico'
      }, {
        type: 'date',
        label: 'Dt. Manutenção',
        field: 'data_manutencao'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Todos', 'Em aberto', 'Orçada', 'Autorizada', 'Cancelada', 'Exportada (NFe/NFSe)', 'Não autorizada', 'Análise do cliente', 'Em andamento', 'Finalizada', 'Aguardando Componentes', 'Serviço Concluído', 'Finalizada sem concerto', 'Aprovado', 'Sem defeito']
      }]
    }
  }), _vm.actionsStore.selectedRows.length > 0 ? _c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: 'Mais ações',
      expression: "'Mais ações'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "mb-5",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "50px"
    },
    attrs: {
      "id": "menu",
      "variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('Menu', {
          attrs: {
            "size": 18
          }
        })];
      },
      proxy: true
    }], null, false, 2976318409)
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.atualizarOS",
      modifiers: {
        "atualizarOS": true
      }
    }]
  }, [_vm._v(" Atualizar status ")]), !_vm.store.pafNFCe && ((_vm$actionsStore$sele = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele === void 0 ? void 0 : _vm$actionsStore$sele.status) != 5 ? _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.faturarOS",
      modifiers: {
        "faturarOS": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1 || ((_vm$actionsStore$sele2 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele2 === void 0 ? void 0 : _vm$actionsStore$sele2.status) == 14
    }
  }, [_vm._v(" Faturar OS Simp. ")]) : _vm._e(), ((_vm$actionsStore$sele3 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele3 === void 0 ? void 0 : _vm$actionsStore$sele3.status) == 14 ? _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.estornarOSModal",
      modifiers: {
        "estornarOSModal": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length <= 0
    }
  }, [_vm._v(" Estornar OS Simp. ")]) : _vm._e()], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "atualizarOS",
      "title": "Deseja atualizar o status da(s) OS selecionada(s)?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          ref: "updateOS",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.atualizarStatus
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_vm._v("OS(s) para mudar o status "), _c('p', [_vm._v(" Número(s): " + _vm._s(_vm.actionsStore.selectedRows.map(function (os) {
    return os.numero;
  }).join(",")) + " ")])]), _c('b-form-group', {
    attrs: {
      "label": "Selecione o status",
      "label-for": "status"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatus",
    attrs: {
      "filterable": false,
      "options": _vm.osStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.statusSelected,
      callback: function callback($$v) {
        _vm.statusSelected = $$v;
      },
      expression: "statusSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o status ")])], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "faturarOS",
      "title": "Deseja faturar a OS Simplificada?",
      "centered": "",
      "size": "md"
    },
    on: {
      "show": function show($event) {
        _vm.comprovantePagamento = null;
      }
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('div', [_c('b-button', {
          ref: "faturarOrdemServico",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary",
            "disabled": _vm.permitido_faturar
          },
          on: {
            "click": _vm.faturarOrdemServico
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_c('p', [_c('strong', [_vm._v("OS Simplificada a ser faturada número: " + _vm._s((_vm$actionsStore$sele4 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele4 === void 0 ? void 0 : _vm$actionsStore$sele4.numero) + " ")])]), (_vm$actionsStore$sele5 = _vm.actionsStore.selectedRows[0]) !== null && _vm$actionsStore$sele5 !== void 0 && _vm$actionsStore$sele5.pagamentos ? _c('p', [_vm._v(" Forma Pagamento: " + _vm._s(_vm.formataPagamento((_vm$actionsStore$sele6 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele6 === void 0 ? void 0 : _vm$actionsStore$sele6.pagamentos)) + " ")]) : _vm._e()]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('p', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v("Gerar financeiro")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.gerar_financeiro,
      expression: "gerar_financeiro"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gerar_financeiro) ? _vm._i(_vm.gerar_financeiro, null) > -1 : _vm.gerar_financeiro
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.gerar_financeiro,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gerar_financeiro = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.gerar_financeiro = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.gerar_financeiro = $$c;
        }
      }
    }
  }), _c('span')])])]), _c('b-col', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_faturamento",
      "label-for": "data_faturamento",
      "label": "Data do Faturamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "required": ""
    },
    model: {
      value: _vm.data_faturamento,
      callback: function callback($$v) {
        _vm.data_faturamento = $$v;
      },
      expression: "data_faturamento"
    }
  })], 1)], 1), _vm.gerar_financeiro ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" Comprovante de pagamento (PDF, JPG/JPEG ou PNG, opcional) "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'O arquivo será anexado às parcelas desta OS no Contas a Receber. Limite de 10 MB.',
            expression: "'O arquivo será anexado às parcelas desta OS no Contas a Receber. Limite de 10 MB.'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "ml-1 text-primary cursor-pointer"
        }, [_c('InformationOutline', {
          attrs: {
            "size": 16
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 522080152)
  }, [_c('b-form-file', {
    attrs: {
      "size": "sm",
      "accept": "application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png",
      "placeholder": "Selecionar arquivo"
    },
    model: {
      value: _vm.comprovantePagamento,
      callback: function callback($$v) {
        _vm.comprovantePagamento = $$v;
      },
      expression: "comprovantePagamento"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "estornarOSModal",
      "title": "Estornar OS Simp.?",
      "size": "md",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var ok = _ref3.ok,
          cancel = _ref3.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "estornar_os",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.estornarOS
          }
        }, [_vm._v(" Salvar ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', [_c('b-col', [_vm._v(" Deseja estornar a OS número: " + _vm._s((_vm$actionsStore = _vm.actionsStore) === null || _vm$actionsStore === void 0 || (_vm$actionsStore = _vm$actionsStore.selectedRows[0]) === null || _vm$actionsStore === void 0 ? void 0 : _vm$actionsStore.numero) + " ")])], 1)], 1)], 1)]), _c('TableApp', {
    ref: "osListSimplificadaSimplificada",
    attrs: {
      "titulo": "OS - Simplificada",
      "acaoBtn": "/#/simplificada-nova",
      "textoBtn": "Nova OS - Simplificada",
      "api-url": "/simplificada/lista",
      "fields": _vm.fields,
      "classFilterColumn": "numero",
      "perPage": 10,
      "multiselect": true
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'numero' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "numero"
          },
          slot: "numero"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.numero) + " ")])])]) : _vm._e(), props.field == 'cliente' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "cliente"
          },
          slot: "cliente"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.cliente) + " "), props.rowData.descricao ? _c('p', {
          staticStyle: {
            "margin-bottom": "0rem",
            "font-size": "10px"
          }
        }, [_vm._v(" Descrição: " + _vm._s(props.rowData.descricao) + " ")]) : _vm._e()])])]) : _vm._e(), props.field == 'objeto' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "objeto"
          },
          slot: "objeto"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [props.rowData.objeto ? _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.objeto.descricao) + " ")]) : _vm._e()])]) : _vm._e(), props.field == 'tecnico' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "tecnico"
          },
          slot: "tecnico"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [props.rowData.tecnico ? _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.tecnico.nome) + " ")]) : _c('div', {
          staticClass: "font-weight-bold"
        })])]) : _vm._e(), props.field == 'data_manutencao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "data_manutencao"
          },
          slot: "data_manutencao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.data_manutencao, "DD/MM/YYYY")) + " ")])])]) : _vm._e(), props.field == 'status' ? _c('span', {
          class: _vm.statusOSClass(props.rowData.status),
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [_vm._v(" " + _vm._s(_vm.statusOSLabel(props.rowData.status)) + " ")]) : _vm._e(), props.field == 'valor' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "valor"
          },
          slot: "valor"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.valor, 2)) + " ")]) : _vm._e(), props.field == 'actions' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Impressão',
            expression: "'Impressão'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.imprimirOS(props.rowData);
            }
          }
        }, [_c('PdfIcon', {
          attrs: {
            "size": 22
          }
        })], 1), props.rowData.status !== 3 && props.rowData.status !== 11 && props.rowData.status !== 12 && props.rowData.status !== 14 && props.rowData.status !== 5 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Editar',
            expression: "'Editar'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.editarOS(props.rowData);
            }
          }
        }, [_c('PencilIcon', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), props.rowData.status != 5 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Deletar',
            expression: "'Deletar'"
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.deleteOS(props.rowData);
            }
          }
        }, [_c('Close', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), props.rowData.status == 14 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'OS Faturada',
            expression: "'OS Faturada'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.linkOSFaturada(props.rowData);
            }
          }
        }, [_c('Money', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e()])]) : _vm._e()];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };